import React from "react";
import { Testimonials } from "./Props";
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

const Review = () => {
    const options = {
        loop: true,
        margin: 20,
        nav: false,
        dots: true,
        responsive: {
            0: {
                items: 1 // Mobile par 1 card full width
            },
            768: {
                items: 2 // Tablet par 2 cards
            },
            1000: {
                items: 3 // Desktop par 3 cards
            }
        }
    }

    return (
        <>
            <div className="review-block" id="Review">
                <div className="container">
                    <div className="review-row">
                        <OwlCarousel className='owl-theme item-m' {...options}>
                            <Testimonials quot="../assets/img/quot.png" text="Dan tristique usto duision vitae diamen neque nivamus aesta atene artines arinianu ateli finibus viverra nec lacus. Nedana dinoz setlie suscipe none misster cuvvan tristique. Developer inila duman aten elit finibus viveracus themone the dru" reviewphoto="../assets/img/5.jpeg" name="Olivia & Enrico" work="Wedding Shooting" />
                            <Testimonials quot="../assets/img/quot.png" text="Dan tristique usto duision vitae diamen neque nivamus aesta atene artines arinianu ateli finibus viverra nec lacus. Nedana dinoz setlie suscipe none misster cuvvan tristique. Developer inila duman aten elit finibus viveracus themone the dru" reviewphoto="../assets/img/6.jpeg" name="Fredia & Pabloe" work="Wedding Shooting" />
                            <Testimonials quot="../assets/img/quot.png" text="Dan tristique usto duision vitae diamen neque nivamus aesta atene artines arinianu ateli finibus viverra nec lacus. Nedana dinoz setlie suscipe none misster cuvvan tristique. Developer inila duman aten elit finibus viveracus themone the dru" reviewphoto="../assets/img/7.jpeg" name="Eleanor & Stefano" work="Wedding Shooting" />
                            <Testimonials quot="../assets/img/quot.png" text="Dan tristique usto duision vitae diamen neque nivamus aesta atene artines arinianu ateli finibus viverra nec lacus. Nedana dinoz setlie suscipe none misster cuvvan tristique. Developer inila duman aten elit finibus viveracus themone the dru" reviewphoto="../assets/img/5.jpeg" name="Olivia & Enrico" work="Wedding Shooting" />
                            <Testimonials quot="../assets/img/quot.png" text="Dan tristique usto duision vitae diamen neque nivamus aesta atene artines arinianu ateli finibus viverra nec lacus. Nedana dinoz setlie suscipe none misster cuvvan tristique. Developer inila duman aten elit finibus viveracus themone the dru" reviewphoto="../assets/img/6.jpeg" name="Fredia & Pabloe" work="Wedding Shooting" />
                            <Testimonials quot="../assets/img/quot.png" text="Dan tristique usto duision vitae diamen neque nivamus aesta atene artines arinianu ateli finibus viverra nec lacus. Nedana dinoz setlie suscipe none misster cuvvan tristique. Developer inila duman aten elit finibus viveracus themone the dru" reviewphoto="../assets/img/7.jpeg" name="Eleanor & Stefano" work="Wedding Shooting" />
                        </OwlCarousel>
                    </div>
                </div>
            </div>
        </>
    );
}
export default Review;